import styled from '@emotion/styled';
import { bodyB, bodyM, largeTitle, title2 } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';

export const Wrapper = styled.section`
  position: relative;
  width: 100%;
  min-height: 477px;

  display: flex;
  justify-content: center;
  align-items: center;

  white-space: pre-line;
`;

export const LogoText = styled.span`
  ${bodyB};
  color: #e31700;

  ${DESKTOP} {
    ${bodyB};
    color: #e31700;
  }
`;

export const Title = styled.span`
  ${title2};
  color: ${vars.neutral[0]};

  text-align: center;

  ${DESKTOP} {
    ${largeTitle};
    color: ${vars.neutral[0]};
  }
`;

export const Description = styled.p`
  ${bodyM};
  color: ${vars.neutral[50]};

  text-align: center;
  margin: 0 auto;

  ${DESKTOP} {
    ${bodyM};
    color: ${vars.neutral[50]};
  }
`;
